export default "__VITE_ASSET__DpY00N1e__"